Ext.define('SA.view.BusinessesViewToolbar', {
    extend: 'SA.view.Toolbar',

    initComponent() {
        var fill = {xtype: 'pvt-fill'},
            locationLabel = {xtype: 'pvt-text', text: 'in'},
            exportBtn = {xtype: 'pvt-export-button', margin: '0 10 0 0'},
            countText = this.getResultCountText(),
            searchCombo = this.getSearchCombo(),
            locationCombo = this.getLocationCombo(),
            viewActionsCombo = this.getViewActionsMenuButton();

        this.items = [countText, searchCombo, locationLabel, locationCombo, fill, viewActionsCombo, exportBtn];

        this.callParent();
    },

    getLocationCombo() {
        var projectView = this.model,
            projectModel = this.model.getProject();

        return {xtype: 'pvt-auto-refreshing-location-dropdown', projectView, projectModel};
    },

    getResultCountText() {
        var model = this.model;

        return {
            xtype: 'component',
            cls: 'sa-pvt-text',

            tpl: [
                '<tpl if="total == null">',
                    'Loading results for',
                '<tpl elseif="total == 1">',
                    '1 result for',
                '<tpl else>',
                    '{total} results for',
                '</tpl>'
            ],

            listeners: {
                beforerender(cmp) {
                    cmp.refresh();

                    cmp.mon(model, 'change:loadstate', cmp.refresh, cmp);
                }
            },

            refresh() {
                this.update({total: model.getTotal()});
            }
        };
    },

    getSearchCombo() {
        var model = this.model,
            project = model.getProject();

        return {
            xtype: 'combo-button',
            textField: 'name',
            ui: 'underline',
            valueField: 'id',

            listeners: {
                beforerender(cmp) {
                    cmp.refresh();

                    cmp.mon(model, 'change:businessSearch', cmp.refresh, cmp);
                    cmp.mon(project, 'change:businessSearch', cmp.refreshItems, cmp);
                }
            },

            buildItems() {
                return SA.data.BusinessSearches.get(project.getBusinessSearches());
            },

            refresh() {
                var search = model.getBusinessSearch();

                if (search) {
                    this.setValue(search);
                }
            },

            selectHandler(businessSearchId) {
                model.setBusinessSearch(businessSearchId);
                model.save();

                SA.data.BusinessSearches.updateTimestamp(businessSearchId);
            }
        };
    },

    getViewActionsMenuButton() {
        var projectView = this.model,
            customItems = [{text: 'Columns', menu: {xtype: 'business-report-columns-menu', projectView}}];

        return SA.view.ViewActionsMenuBuilder.build({projectView, customItems});
    }
});